const calculateTwoWay = (odds, desiredMargin) => {
  const [k1, k2] = odds;
  if (k1 > k2) {
    const newOdds = calculateTwoWay([k2, k1], desiredMargin);
    return newOdds.reverse();
  }
  const margin = desiredMargin / 100;
  const a = margin * (k2 - 1) / (k1 - 1);
  const b = ((k2 - 1) / (k1 - 1) + 1) * (margin - 1);
  const c = -(2 - margin);
  const n1 = (-b + (b ** 2 - 4 * a * c) ** 0.5) / (2 * a) + 1;
  const n2 = 1 / (margin - 1 / n1);
  return [n1, n2];
};
const calculateThreeWay = (odds, desiredMargin) => {
  const margin = desiredMargin / 100;
  const k1 = Math.min(...odds);
  const k1i = odds.indexOf(k1);
  const k3 = Math.max(...odds);
  const k3i = odds.lastIndexOf(k3);
  const k2i = 3 - k1i - k3i;
  const k2 = odds[k2i];
  const alpha2 = (k2 - 1) / (k1 - 1);
  const alpha3 = (k3 - 1) / (k1 - 1);
  const a = alpha2 * alpha3 * margin;
  const b = (alpha2 + alpha3 + alpha2 * alpha3) * (margin - 1);
  const c = (alpha2 + alpha3 + 1) * (margin - 2);
  const d = -(3 - margin);
  const p = (b ** 2 - 3 * a * c) / (3 * a ** 2);
  const q = (2 * b ** 3 - 9 * a * b * c + 27 * d * a ** 2) / (27 * a ** 3);
  const discriminant = (q / 2) ** 2 - (p / 3) ** 3;
  if (discriminant >= 0) {
    return odds;
  }
  const phi = Math.acos(q / (2 * (p / 3) ** 1.5));
  const n1 = -2 * (p / 3) ** 0.5 * Math.cos(phi / 3 + 2 / 3 * Math.PI) - b / (3 * a) + 1;
  const [n2, n3] = calculateTwoWay([k2, k3], (margin - 1 / n1) * 100);
  const res = [];
  res[k1i] = n1;
  res[k2i] = n2;
  res[k3i] = n3;
  return [res[0], res[1], res[2]];
};
const calculateOddsBoost = (odds, desiredMargin) => {
  if (odds.length === 3) {
    return calculateThreeWay(odds, desiredMargin);
  }
  return calculateTwoWay(odds, desiredMargin);
};
export {
  calculateOddsBoost,
  calculateThreeWay,
  calculateTwoWay
};
